// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"152900e23297f5b5cc89","263":"bfa79e42773f4328dd86","791":"fa01ae5256c02488d99b"}[chunkId] + ".js";
};